var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h2", [_vm._v("NIEM Mapping Template")]),
      _c("p", [
        _vm._v(
          "Spreadsheets are often used with NIEM for a variety of purposes.  There is enough overlap in some of the primary use cases for a standard template, which allows for the development of automated QA, data import, and translation into other formats."
        )
      ]),
      _c("p", [
        _c(
          "a",
          {
            staticClass: "btn btn-sm btn-info",
            attrs: {
              download: "",
              href: "templates/niem-mapping-template.xlsx"
            }
          },
          [
            _c("i", { staticClass: "fa fa-download" }),
            _vm._v(" Download NIEM mapping template\n    ")
          ]
        )
      ]),
      _c("br"),
      _c("h2", [_vm._v("Example use cases")]),
      _c("p", [
        _vm._v(
          "The table below shows some standard use cases for the NIEM mapping template spreadsheet, plus an overview of how the spreadsheet should be filled in."
        )
      ]),
      _c("table", { staticClass: "table" }, [
        _c("thead", [
          _c("tr", [
            _c("th", { staticClass: "th_useCase" }, [
              _vm._v("Example use case")
            ]),
            _c("th", { staticClass: "th_source" }, [_vm._v("Source columns")]),
            _c("th", { staticClass: "th_mapping" }, [
              _vm._v("Mapping columns")
            ]),
            _c("th", { staticClass: "th_target" }, [_vm._v("Target columns")])
          ])
        ]),
        _c("tbody", [
          _c("tr", [
            _c("td", [_c("b", [_vm._v("Map a standard to NIEM")])]),
            _c("td", [_vm._v("Standard fields")]),
            _c("td", [
              _vm._v("Mapping info"),
              _c("br"),
              _c("em", [_vm._v("map, no match")])
            ]),
            _c("td", [_vm._v("NIEM release components")])
          ]),
          _c("tr", [
            _c("td", [
              _c("b", [_vm._v("Map local exchange requirements for an IEPD")])
            ]),
            _c("td", [_vm._v("Local requirements")]),
            _c("td", [
              _vm._v("Mapping info"),
              _c("br"),
              _c("em", [_vm._v("map, no match, add")])
            ]),
            _c("td", [_vm._v("NIEM components and extensions")])
          ]),
          _c("tr", [
            _c("td", [_c("b", [_vm._v("Change request spreadsheet")])]),
            _c("td", [_vm._v("Source info or n/a")]),
            _c("td", [
              _vm._v("Change operations"),
              _c("br"),
              _c("em", [_vm._v("add, edit, delete")])
            ]),
            _c("td", [_vm._v("New or modified NIEM components")])
          ]),
          _c("tr", [
            _c("td", [_c("b", [_vm._v("Document NIEM sources")])]),
            _c("td", [_vm._v("Source info")]),
            _c("td", [
              _vm._v("Mapping info"),
              _c("br"),
              _c("em", [_vm._v("map")])
            ]),
            _c("td", [_vm._v("NIEM components")])
          ]),
          _c("tr", [
            _c("td", [_c("b", [_vm._v("Foreign language translations")])]),
            _c("td", [_vm._v("Translated names and definitions")]),
            _c("td", [
              _vm._v("Mapping info"),
              _c("br"),
              _c("em", [_vm._v("map")])
            ]),
            _c("td", [_vm._v("NIEM components")])
          ]),
          _c("tr", [
            _c("td", [_c("b", [_vm._v("NIEM release documentation")])]),
            _c("td", [_vm._v("n/a")]),
            _c("td", [
              _vm._v("Mapping info"),
              _c("br"),
              _c("em", [_vm._v("documentation")])
            ]),
            _c("td", [_vm._v("NIEM components")])
          ]),
          _c("tr", [
            _c("td", [_c("b", [_vm._v("NIEM change log")])]),
            _c("td", [_vm._v("Old NIEM release")]),
            _c("td", [
              _vm._v("Mapping info"),
              _c("br"),
              _c("em", [_vm._v("add, edit, delete, no change")])
            ]),
            _c("td", [_vm._v("New NIEM release")])
          ])
        ])
      ]),
      _c("br"),
      _c("h2", [_vm._v("IEPD requirements example")]),
      _c("p", [
        _vm._v(
          "Download the IEPD requirements example spreadsheet below for a demonstration of how this template may be used.  This spreadsheet uses components from "
        ),
        _c("a", { attrs: { href: "https://schema.org", target: "_blank" } }, [
          _vm._v("schema.org")
        ]),
        _vm._v(" as sample exchange data requirements.")
      ]),
      _c("p", [
        _c(
          "a",
          {
            staticClass: "btn btn-sm btn-info",
            attrs: {
              download: "",
              href: "/examples/iepd-requirements-example.xlsx"
            }
          },
          [
            _c("i", { staticClass: "fa fa-download" }),
            _vm._v(' Download "IEPD requirements mapping" example\n    ')
          ]
        )
      ]),
      _c("p", [
        _vm._v(
          "In this case, source columns (blue column headers) represent the requirements from schema.org and target columns (red column headers) represent the mappings to NIEM components and newly-created NIEM extensions modeled for this sample IEPD."
        )
      ]),
      _c("table", { staticClass: "table table-hover" }, [
        _c("thead", [
          _c("tr", [
            _c("th", { staticClass: "th_useCase" }, [
              _vm._v("Example mapping")
            ]),
            _c("th", { staticClass: "th_source" }, [
              _vm._v("Source columns "),
              _c("br"),
              _vm._v("(exchange requirements)")
            ]),
            _c("th", { staticClass: "th_mapping" }, [
              _vm._v("Mapping columns "),
              _c("br"),
              _vm._v("(code, optional notes)")
            ]),
            _c("th", { staticClass: "th_target" }, [
              _vm._v("Target columns "),
              _c("br"),
              _vm._v("(NIEM + IEPD extensions)")
            ])
          ])
        ]),
        _c("tbody", [
          _c("tr", [
            _c("td", [
              _vm._v(
                "Requirement does not exist in NIEM; must be added as a NIEM IEPD extension"
              )
            ]),
            _c("td", [_vm._v("actor")]),
            _c("td", [_vm._v("add")]),
            _c("td", [_vm._v("ext:MovieActor")])
          ]),
          _c("tr", [
            _c("td", [
              _vm._v(
                "Requirement maps to NIEM; will be included with NIEM subset in IEPD"
              )
            ]),
            _c("td", [_vm._v("givenName")]),
            _c("td", [_vm._v("map")]),
            _c("td", [_vm._v("nc:PersonGivenName")])
          ])
        ])
      ]),
      _c("br"),
      _c("h2", [_vm._v("Current status")]),
      _c("div", { staticClass: "alert alert-info" }, [
        _c("ul", { staticClass: "ul_checkList" }, [
          _c("li", [
            _c("i", { staticClass: "fa fa-fw fa-square-o" }),
            _vm._v(" Run QA - "),
            _c("em", [_vm._v("In progress")])
          ]),
          _c("ul", { staticClass: "ul_checkList" }, [
            _c("li", [
              _vm._v(" -- "),
              _c("i", { staticClass: "fa fa-fw fa-square-o" }),
              _vm._v(
                " Spreadsheet checks: required tabs, columns, fields, formats"
              )
            ]),
            _c("li", [
              _vm._v(" -- "),
              _c("i", { staticClass: "fa fa-fw fa-square-o" }),
              _vm._v(" Content checks: valid values")
            ])
          ]),
          _c("li", [
            _c("i", { staticClass: "fa fa-fw fa-square-o" }),
            _vm._v(" Generate SSGT wantlist")
          ]),
          _c("li", [
            _c("i", { staticClass: "fa fa-fw fa-square-o" }),
            _vm._v(" Generate NIEM extension schemas")
          ])
        ])
      ]),
      _c("br")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }